import React from "react";
import "../assets/sass/shareStyle.scss";

export default function LogoPage() {
  return (
    <div className="logo__container">
      <div className="logo__content">
        <span className="logo__content_highlight">cc</span>gloves
      </div>
    </div>
  );
}
